import React, { useEffect, useRef } from "react";

interface MathRendererProps {
  content: string;
}

const MathRenderer: React.FC<MathRendererProps> = ({ content }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    containerRef.current.innerHTML = content;

    const renderMath = () => {
      const MathJax = (window as any).MathJax;

      // Check if MathJax is fully loaded with typesetPromise available
      if (
        MathJax?.typesetPromise &&
        typeof MathJax.typesetPromise === "function"
      ) {
        MathJax.typesetPromise([containerRef.current]).catch((err: any) =>
          console.error("MathJax render error:", err)
        );
      } else if (!document.querySelector('script[src*="mathjax"]')) {
        // Only load script if not already loading
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src =
          "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js";
        script.async = true;
        script.onload = () => {
          const loadedMathJax = (window as any).MathJax;
          if (loadedMathJax?.typesetPromise && containerRef.current) {
            loadedMathJax
              .typesetPromise([containerRef.current])
              .catch((err: any) => console.error("MathJax render error:", err));
          }
        };
        document.head.appendChild(script);
      } else {
        // Script is loading, retry after a short delay
        setTimeout(renderMath, 100);
      }
    };

    renderMath();
  }, [content]);

  return <div ref={containerRef}></div>;
};

export default MathRenderer;
